const mapToOptions = (items: string[]) =>
	items.map((item) => ({ value: item, label: item }));

export const regionOptions = [
	{ value: "0", label: "Central" },
	{ value: "1", label: "East" },
	{ value: "2", label: "North" },
	{ value: "3", label: "Northeast" },
	{ value: "4", label: "West" },
];

const estates = [
	"Bedok Reservoir",
	"Braddell",
	"Marina Bay",
	"Raffles Place",
	"Chinatown",
	"Downtown",
	"Anson",
	"Tanjong Pagar",
	"Harbourfront",
	"Telok Blangah",
	"Pasir Panjang",
	"Clementi",
	"Dover",
	"Queenstown",
	"Bukit Merah",
	"Tiong Bahru",
	"Beach Road",
	"Bugis",
	"Golden Mile",
	"Little India",
	"Orchard",
	"Tanglin",
	"Bukit Timah",
	"Holland",
	"Novena",
	"Thomson",
	"Watten Estate",
	"Toa Payoh",
	"Balestier",
	"Kallang",
	"Aljunied",
	"Potong Pasir",
	"Macpherson",
	"Bidadari",
	"Geylang",
	"Stadium",
	"Eunos",
	"Paya Lebar",
	"Joo Chiat",
	"Katong",
	"Marine Parade",
	"East Coast",
	"Bedok",
	"Upper East Coast",
	"Loyang",
	"Pasir Ris",
	"Tampines",
	"Hougang",
	"Sengkang",
	"Serangoon",
	"Ang Mo Kio",
	"Bishan",
	"Upper Bukit Timah",
	"Jurong East",
	"Boon Lay",
	"Pioneer",
	"Tuas",
	"Jurong West",
	"Bukit Batok",
	"Hillview",
	"Bukit Panjang",
	"CCK",
	"Western Water Catchment",
	"Tengah",
	"Lim Chu Kang",
	"Kranji",
	"Woodlands",
	"Mandai",
	"Sembawang",
	"Yishun",
	"Upper Thomson",
	"Thompson",
	"Seletar",
	"Changi",
	"Punggol",
];

export const estateOptions = [
	{ value: "", label: "All estate" },
	...mapToOptions(estates),
];

export const jobOptions = [
	{ value: "", label: "All job type" },
	{ value: "0", label: "Inspection" },
	{ value: "1", label: "Servicing" },
	{ value: "2", label: "Refuelling" },
	{ value: "3", label: "Preventive Maintenance" },
	{ value: "4", label: "Deployment" },
	{ value: "5", label: "Reactive Maintenance" },
	{ value: "6", label: "EV Charging" },
];

export const carSeatOptions = [
	{ value: "", label: "Select Seats" },
	...[2, 3, 4, 5, 6, 7, 8, 9].map((n) => ({ value: n, label: String(n) })),
];

export const carStatusOptions = [
	{ id: "1", label: "Active" },
	{ id: "2", label: "Inactive - Others" },
	{ id: "3", label: "Inactive - In Workshop" },
	{ id: "4", label: "Inactive - Decommissioned" },
	{ id: "5", label: "Inactive - Scrapped" },
];

export const vehicleStatusOptions = [
	{ id: "active", label: "Active", variant: "success" },
	{
		id: "inactive-in-workshop",
		label: "Inactive - In Workshop",
		variant: "pending",
	},
	{ id: "inactive-others", label: "Inactive - Others", variant: "neutral" },
	{ id: "inactive-in-lot", label: "Inactive - In Lot", variant: "neutral" },
	{
		id: "inactive-decommissioned",
		label: "Inactive - Decommissioned",
		variant: "dark",
	},
	{ id: "inactive-scrapped", label: "Inactive - Scrapped", variant: "dark" },
];

// Vehicle status label -> status badge variant, for CustomTableBadge.
export const vehicleStatusVariantByLabel = Object.fromEntries(
	vehicleStatusOptions.map((option) => [option.label, option.variant])
);

export const readyForCollectionOptions = [
	{ value: "Yes", label: "Yes" },
	{ value: "No", label: "No" },
];

export const serviceCategoriesToOptions = (items) =>
	(items ?? []).map(({ code, label }) => ({ value: code, label }));

// `value` is the raw wire status from the Issues API (e.g. "InProgress");
// `label` is the display text.
export const issueStatusOptions = [
	{ id: "backlog", value: "Backlog", label: "Backlog", variant: "neutral" },
	{
		id: "assigned",
		value: "Assigned",
		label: "Assigned",
		variant: "primary",
	},
	{
		id: "in-progress",
		value: "InProgress",
		label: "In Progress",
		variant: "pending",
	},
	{
		id: "completed",
		value: "Completed",
		label: "Completed",
		variant: "success",
	},
	{
		id: "cancelled",
		value: "Cancelled",
		label: "Cancelled",
		variant: "dark",
	},
];

// `value` is the raw wire status from the Jobs API (e.g. "open"); `label` is
// the display text. Mirrors jobStatusFilter's status set above.
export const jobStatusOptions = [
	{ id: "open", value: "open", label: "Open", variant: "neutral" },
	{
		id: "assigned",
		value: "assigned",
		label: "Assigned",
		variant: "primary",
	},
	{ id: "ongoing", value: "ongoing", label: "Ongoing", variant: "pending" },
	{ id: "paused", value: "paused", label: "Paused", variant: "neutral" },
	{
		id: "completed",
		value: "completed",
		label: "Completed",
		variant: "success",
	},
	{
		id: "incomplete",
		value: "incomplete",
		label: "Incomplete",
		variant: "pending",
	},
	{
		id: "cancelled",
		value: "cancelled",
		label: "Cancelled",
		variant: "dark",
	},
];

export const flaggedOptions = [
	{ value: "Yes", label: "Yes" },
	{ value: "No", label: "No" },
];

export const pageSizeOptions = [
	{ value: "10", label: "Show 10" },
	{ value: "20", label: "Show 20" },
	{ value: "50", label: "Show 50" },
];

export const reportStatusOptions = [
	{ value: "", label: "All Status" },
	{ value: "0", label: "Pending Review" },
	{ value: "1", label: "Rejected" },
	{ value: "2", label: "Accepted" },
	{ value: "3", label: "Approved" },
];

export const carparkStatusOptions = [
	{ value: "", label: "All statuses" },
	{ value: "1", label: "Active" },
	{ value: "0", label: "Inactive" },
];

export const evStatusOptions = [
	{ value: "", label: "All Status" },
	{ value: "1", label: "Active" },
	{ value: "0", label: "Inactive" },
];

export const userStatusOptions = [
	{ value: "", label: "All Status" },
	{ value: "0", label: "Active" },
	{ value: "1", label: "Inactive" },
	{ value: "3", label: "Pending" },
];

export const fmsUserStatusOptions = [
	{ value: "", label: "All Status" },
	{ value: "true", label: "Active" },
	{ value: "false", label: "Inactive" },
];

export const groupStatusOptions = [
	{ value: "", label: "All Status" },
	{ value: "0", label: "Active" },
	{ value: "1", label: "Inactive" },
];

export const damageAreaOptions = [
	"Front",
	"Driver side",
	"Passenger side",
	"Back",
].map((val) => ({ name: "damageArea", value: val, label: val }));

export const carSectionOptions = [
	{
		name: "damageArea",
		value: "",
		label: "All Damage Area",
	},
	...damageAreaOptions,
];

export const damageTypeOptions = [
	"Dent",
	"Crack",
	"Scratch",
	"Missing",
	"Misalign",
	"Broken",
	"Tyre",
	"Others",
].map((val) => ({ name: "damageType", value: val, label: val }));

export const driveDamageTypeOptions = [
	"Headlight",
	"Wiper",
	"Dashboard",
	"Brakes",
	"Others",
].map((val) => ({ name: "driveDamageType", value: val, label: val }));

export const damageTypeOptionsSelect = [
	{
		name: "damageType",
		value: "",
		label: "All Damage Type",
	},
	...[
		"Dent",
		"Crack",
		"Scratch",
		"Missing",
		"Detach",
		"Misalign",
		"Broken",
		"Tyre",
	].map((val) => ({ name: "damageType", value: val, label: val })),
	...driveDamageTypeOptions,
];

export const damageCategory = [
	{
		name: "damageCategory",
		value: "Exterior",
		label: "Exterior",
	},
	{
		name: "damageCategory",
		value: "Drive",
		label: "Drive",
	},
];

export const reportSectionOptions = [
	{
		name: "damageCategory",
		value: "",
		label: "All Report Section",
	},
	...damageCategory,
];

export const drivingLicenceClassSGOptions = [
	{ value: "1", label: "3" },
	{ value: "2", label: "3A" },
	{ value: "3", label: "3C" },
	{ value: "4", label: "3CA" },
	{ value: "5", label: "2" },
	{ value: "6", label: "2A" },
	{ value: "7", label: "2B" },
	{ value: "8", label: "4" },
	{ value: "9", label: "4A" },
	{ value: "10", label: "5" },
	{ value: "11", label: "IDP" },
];

export const drivingLicenceClassAUOptions = [
	{ value: "100", label: "C" },
	{ value: "101", label: "LR" },
	{ value: "102", label: "MR" },
	{ value: "103", label: "HR" },
	{ value: "104", label: "HC" },
	{ value: "105", label: "MC" },
	{ value: "11", label: "IDP" },
	{ value: "12", label: "Foreign" },
];

//For Vehicle Issues
export const VehicleCarSectionOptions = [
	{ name: "damageArea", value: "0", label: "NA" },
	{ name: "damageArea", value: "1", label: "Front" },
	{ name: "damageArea", value: "2", label: "Driver side" },
	{ name: "damageArea", value: "3", label: "Passenger side" },
	{ name: "damageArea", value: "4", label: "Back" },
	{ name: "damageArea", value: "5", label: "Rear" },
];

//For Vehicle Issues
export const VehicleReportSectionOptions = [
	{ name: "damageCategory", value: "0", label: "Not Applicable" },
	{ name: "damageCategory", value: "1", label: "Drive" },
	{ name: "damageCategory", value: "2", label: "Cleanliness" },
	{ name: "damageCategory", value: "3", label: "Exterior" },
];

//For Vehicle Issues
export const VehicleDamageTypeOptions = [
	{ name: "damageType", value: "3", label: "Dent" },
	{ name: "damageType", value: "2", label: "Crack" },
	{ name: "damageType", value: "1", label: "Scratch" },
	{ name: "damageType", value: "4", label: "Missing" },
	{ name: "damageType", value: "5", label: "Detach" },
	{ name: "damageType", value: "6", label: "Others" },
];

export const cmmDamageTypeOptions = [
	"NA",
	"Scratch",
	"Crack",
	"Dent",
	"Missing",
	"Detach",
	"Broken",
	"Misalign",
	"Brakes",
	"Dashboard",
	"Headlight",
	"Tyre",
	"Wiper",
	"Others",
].map((label, index) => ({ name: "damageType", value: String(index), label }));

export const cmmRejectReasonOptions = [
	"Irrelevant",
	"Blur",
	"Not Billable",
].map((label, index) => ({
	name: "rejectReason",
	value: String(index),
	label,
}));

export const statusMapStr = {
	Assigned: `<p class="status-bar status-bar-6">Assigned</p>`,
	Open: '<p class="status-bar status-bar-4">Open</p>',
	Taken: '<p class="status-bar status-bar-2">Taken</p>',
	Complete: '<p class="status-bar status-bar-6">Complete</p>',
	Completed: '<p class="status-bar status-bar-6">Completed</p>',
	Incomplete: '<p class="status-bar status-bar-5">Incomplete</p>',
	Deleted: '<p class="status-bar status-bar-3">Deleted</p>',
	Overdue: '<p class="status-bar status-bar-3">Overdue</p>',
	Ongoing: '<p class="status-bar status-bar-8">Ongoing</p>',
	Paused: '<p class="status-bar status-bar-2">Paused</p>',
	Cancelled: '<p class="status-bar status-bar-7">Cancelled</p>',
	Created: '<p class="status-bar status-bar-4">Created</p>',
};

export const jobStatusFilter = {
	active: [
		{ id: "open", name: "Open" },
		{ id: "assigned", name: "Assigned" },
		{ id: "ongoing", name: "Ongoing" },
		{ id: "paused", name: "Paused" },
	],
	past: [
		{ id: "completed", name: "Completed" },
		{ id: "incomplete", name: "Incomplete" },
		{ id: "cancelled", name: "Cancelled" },
	],
};

export const servicingStatus = {
	DueSoon: '<p class="status-bar status-bar-2">Due soon</p>',
	Overdue: '<p class="status-bar status-bar-3">Overdue</p>',
};

export const priorityOptions = [
	{ value: "0", label: "Low" },
	{ value: "1", label: "Medium" },
	{ value: "2", label: "High" },
];
export const rejectedReasonEnum = [
	{ value: "NoDamage", label: "No Damage" },
	{ value: "NoNewDamage", label: "No New Damage" },
];

export const verdictOptions = {
	newDamage: `<p class="status-bar status-bar-danger">New Damage</p>`, // New Damage
	noNewDamage: `<p class="status-bar status-bar-black">No New Damage</p>`, // No New Damage
	noDamage: `<p class="status-bar status-bar-gray">No Damage</p>`, // No Damage
};

export const collisionTypeOptions = mapToOptions([
	"Unknown",
	"Hit/Grazed Wall",
	"Hit/Grazed Pole",
	"Hit/Mount Kerb",
	"Rear Windscreen - Reverse & Hit into Carpark Guard/Railing",
	"Front Windscreen - Hit by Stone/Pebble",
	"Reversed & Hit into 3rd Party",
	"Hit into Bicyclist",
	"Hit into Motorcyclist",
	"Hit into Parked Vehicle",
	"Hit into Pedestrian",
	"Hit into Property - Government",
	"Hit into Property - Private",
	"Collision - Change lane/Side Swipe",
	"Collision - Cross Junction",
	"Collision - Head on (Head to Head)",
	"Collision - Head to Rear (User hit into the rear of 3rd Party)",
	"Collision - Head to Rear (3rd Party hit into rear of User)",
	"Collision - Major/Minor Rd",
	"Collision - Opening Door of Vehicle",
	"Collision - Roundabout",
	"Collision - U-Turn",
	"Chain Collision - User Middle Car",
	"Chain Collision - User Last Car",
	"Chain Collision - User First Car",
	"Drink Driving/Drugs Influence",
	"Hit & Run/Vandalism/Damaged Whilst Parked",
	"Hit by Fallen Tree/Branches/Other Objects",
	"Overturn/Self skid/Lost Control - Major Damage",
	"Vehicle Caught Fire/Flood",
	"Pump Wrong Fuel",
]);

export const caseTypeOptions = mapToOptions(["Accident", "Damage"]);

export const claimTypeOptions = mapToOptions([
	"Cash Repairs",
	"Own Damage Claim",
	"Third Party Claim",
	"Windscreen Claim",
	"Private Settlement",
	"Reporting Only",
	"Unauthorised Driving",
	"Non-Reporting",
	"Tyre Damage",
	"NR Damage",
	"TP Compound",
]);

export const damageLocationOptions = mapToOptions([
	"Front",
	"Front LH",
	"Front RH",
	"Rear",
	"Rear LH",
	"Rear RH",
	"Whole LH",
	"Whole RH",
	"Front windscreen",
	"Rear windscreen",
]);

export const liabilityOptions = mapToOptions([
	"Down (Fully at fault)",
	"50/50 (Partially at fault)",
	"Clear (Not at fault)",
]);

// Desmond, FQ, CXLiveChat, CXEmail, CXCall, TSSelfReported

export const caseOriginOptions = [
	{ value: "Desmond", label: "Desmond" },
	{ value: "FQ", label: "Workshop" },
	{ value: "CXLiveChat", label: "CX - Live Chat" },
	{ value: "CXEmail", label: "CX - Email" },
	{ value: "CXCall", label: "CX - Call" },
	{ value: "TSSelfReported", label: "TS - Self Reported" },
	{ value: "Operator", label: "Operator" },
];

export const caseClosingReasonOptions = mapToOptions([
	"Liability Clear",
	"No Visible Damage",
	"Non-repairable damage (VQP 0)",
	"Repairable but not attributable",
	"Insufficient Evidence - previous user no end trip photo",
	"Insufficient Evidence - unclear/low quality photos",
	"Insufficient Evidence - no photo of damaged side",
	"Insufficient Evidence - liability cannot be determined",
	"Wrong case creation",
	"No New Damage",
	"Repudiation",
	"Duplicate case",
	"Damage more than 6 months ago",
]);

export const caseStatusOptions = [
	{ value: "New", label: "New" },
	{ value: "Investigating", label: "Investigating" },
	{ value: "Quoting", label: "Quoting" },
	{ value: "PreBilling", label: "Pre-Billing" },
	{ value: "Rejected", label: "Rejected" },
	{ value: "Closed", label: "Closed" },
];

export const damageAttributionOptions = mapToOptions([
	"Unknown",
	"User",
	"Staff",
	"ThirdParty",
]);

export const costBreakdownInitialValues = [
	{ item: "Repair cost/own damage (section 1) excess", value: undefined },
	{ item: "Towing", value: undefined },
	{ item: "Loss of use", value: undefined },
	{ item: "Third Party Damage (section 2) excess", value: undefined },
	{ item: "Admin Fee", value: undefined },
];

export const popcarPlatformsOptions = [{ id: "3", label: "Popcar" }];

export const getGoPlatformOptions = [
	{ id: "1", label: "GetGo" },
	{ id: "2", label: "ZipZap" },
];

export const caseOriginDisplay = {
	Desmond: "Desmond",
	"CXTS-Email": "CX - Email",
	"CXTS-Call": "CX - Call",
	"CXTS-LiveChat": "CX - Live Chat",
	"CXTS-SelfReported": "TS - Self Reported",
	FQ: "Workshop",
	TSSelfReported: "TS - Self Reported",
	Operator: "Operator",
	Workshop: "Workshop",
};

export const caseOriginDropdownCheckBoxOptions = caseOriginOptions.map(
	(option) => ({
		label: option.label,
		id: option.value,
		selected: false,
	})
);

export const damageLocationDropdownCheckBoxOptions = damageLocationOptions.map(
	(option) => ({
		label: option.label,
		id: option.value,
		selected: false,
	})
);

export const rejectedReasonDropdownCheckBoxOptions = rejectedReasonEnum.map(
	(option) => ({
		label: option.label,
		id: option.value,
		selected: false,
	})
);

export const caseModalTextOptions = {
	quotation: {
		header: `Create Quotation`,
		bodyText: `You are about to create a quotation for this case. Are you sure you want to proceed?`,
	},
	createCase: {
		header: `Create Case`,
		bodyText: `You are about to create a new case. Are you sure you want to proceed?`,
	},
};

export const workOrderStatusOptions = [
	{ value: "Triage", label: "Triage" },
	{ value: "InProgress", label: "In Progress" },
	{ value: "InWorkshop", label: "In Workshop" },
	{ value: "CompletedByWorkshop", label: "Completed by Workshop" },
	{ value: "PendingCompletion", label: "Pending Completion" },
	{ value: "Completed", label: "Completed" },
	{ value: "Cancelled", label: "Cancelled" },
];

// Vehicle activity log type filter (FRNT-5927 / US-6). The API accepts only
// these two values; "All activities" is the absence of an `activityType` param.
export const activityTypeOptions = [
	{ value: "Issue", label: "Issue" },
	{ value: "WorkOrder", label: "Work order" },
];
